import React from "react";
import PortPairs from "../components/PortPairs/portPairs";
import { isValidCoordinates, transformData } from "@helpers/profileHelper";
import { targetSVG } from "./enum";
import withSuspense from "@hoc/withSuspense";
import ProfileTableSkeleton from "@components/templates/Profile/ProfileTable/components/ProfileTableSkeleton";

const TradeLanesTable = React.lazy(() => import("@containers/TradeLanesProfile/components/TradeLanesTable"));

const SuspendedTradeLanesTable = withSuspense(TradeLanesTable, <ProfileTableSkeleton />);

export const renderTradeLanesPanelData = (activeTabId) => {
  let renderTradeLanesPanelData = {
    overview: <PortPairs />,
    freight_forwarder: <SuspendedTradeLanesTable tableName="Freight Forwarders" />,
    vocc: <SuspendedTradeLanesTable tableName="VOCCs" />,
    nvocc: <SuspendedTradeLanesTable tableName="NVOCCs" />,
    vessel: <SuspendedTradeLanesTable tableName="Vessels" />,
    importers: <SuspendedTradeLanesTable tableName="Consignees" />,
    exporters: <SuspendedTradeLanesTable tableName="Shippers" />,
  };
  return renderTradeLanesPanelData[activeTabId];
};

export const getTradeLanesChartData = (mapData) => {
  let data = [];
  let imageData = [];
  let imageDataFrom = new Set();
  if (mapData && Array.isArray(mapData)) {
    for (let i = 0; i < mapData.length; i++) {
      const { doc_count } = mapData[i];
      const { key: fromKey, countryCode, latitude: fromLatitude, longitude: fromLongitude } = mapData[i].from;
      const { latitude: toLatitude, longitude: toLongitude, key: toKey } = mapData[i].to;
      if (isValidCoordinates(fromLatitude, fromLongitude, toLongitude, toLatitude) && doc_count > 0) {
        let obj = {
          portName: transformData(toKey, true, false),
          primaryPortName: transformData(fromKey, true, false),
          shipments: parseInt(doc_count),
        };
        obj.id = countryCode;
        obj.multiGeoLine = [
          [
            { latitude: fromLatitude, longitude: fromLongitude },
            { latitude: toLatitude, longitude: toLongitude },
          ],
        ];
        obj.shipments = parseInt(doc_count);
        data.push({ ...obj });
        let imgDataObj = {
          ...obj,
          id: toKey,
          svgPath: targetSVG,
          title: transformData(toKey, true, false),
          latitude: toLatitude,
          longitude: toLongitude,
          scale: 1,
          radius: 6,
          primaryPortName: null,
          shipments: null,
        };
        let imgDataObjFrom = {
          id: fromKey,
          svgPath: targetSVG,
          title: transformData(fromKey, true, false),
          latitude: fromLatitude,
          longitude: fromLongitude,
          scale: 1,
          radius: 6,
        };
        imageData.push({ ...imgDataObj });
        const stringifiedItem = JSON.stringify(imgDataObjFrom);
        imageDataFrom.add(stringifiedItem);
      }
    }
  }
  const fromArr = Array.from(imageDataFrom).map((item) => JSON.parse(item));
  imageData.push(...fromArr);
  return {
    mapData: data,
    imageData,
  };
};

export const getLineCoordinates = (lineSeries, latitude, longitude) => {
  const imageLatitudes = [];
  const imageLongitudes = [];

  lineSeries.mapLines.each(function (mapLine) {
    const { latitude: lineLatitude, longitude: lineLongitude } = mapLine.multiGeoLine[0][1] || {};
    const { latitude: outLineLatitude, longitude: outlineLongitude } = mapLine.multiGeoLine[0][0] || {};

    if (latitude === lineLatitude && longitude === lineLongitude) {
      imageLatitudes.push(mapLine.multiGeoLine[0][0].latitude);
      imageLongitudes.push(mapLine.multiGeoLine[0][0].longitude);
    } else if (latitude === outLineLatitude && longitude === outlineLongitude) {
      imageLatitudes.push(mapLine.multiGeoLine[0][1].latitude);
      imageLongitudes.push(mapLine.multiGeoLine[0][1].longitude);
    }
  });
  return [imageLatitudes, imageLongitudes];
};

export const updateMapLine = (mapLine, isActive) => {
  mapLine.line.strokeOpacity = isActive ? 1 : 0.02;
  mapLine.arrow.opacity = isActive ? 1 : 0.02;
};

export const updateMapImagesOpacity = (mapImages, latitudes, longitudes) => {
  mapImages.each(function (mapImage) {
    mapImage.opacity = latitudes.includes(mapImage.latitude) && longitudes.includes(mapImage.longitude) ? 1 : 0.02;
  });
};

export const restoreMapImagesOpacity = (mapImages) => {
  mapImages.each(function (mapImage) {
    mapImage.opacity = 1;
  });
};

export const resetMapLinesAppearance = (mapLines) => {
  mapLines.each(function (mapLine) {
    mapLine.line.strokeOpacity = 0.4;
    mapLine.arrow.opacity = 1;
  });
};

export const transformPillData = (lading_region_acronym, lading_trade_data_mapping, unlading_region_acronym, unlading_trade_data_mapping) => {
  return [
    {
      id: 1,
      value: lading_region_acronym + " " + lading_trade_data_mapping?.length + " Ports",
      ports: lading_trade_data_mapping,
      profileType: "portOfLading",
    },
    {
      id: 2,
      value: unlading_region_acronym + " " + unlading_trade_data_mapping?.length + " Ports",
      ports: unlading_trade_data_mapping,
      profileType: "portOfUnlading",
    },
  ];
};

export const getTradeLaneName = (name) => {
  return `Port of ${transformData(name, true, false)}`;
};
